import { Injectable } from "@angular/core";
import { IntegratedAdmissionWizardService } from "./integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { OnLineValidationService } from "src/app/services/on-line-validation/on-line-validation.service";
import { PracticeService } from "src/app/services/practice.service";
import { ValorizationService } from "src/app/services/valorization/valorization.service";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { BudgetService } from "src/app/services/budget/budget.service";
import { MatDialog } from "@angular/material";
import { Observable } from "rxjs";
import { NormativeService } from "src/app/services/normative/normative.service";
import { ReservationService } from "src/app/services/reservation.service";
import { AdmissionGroupedProcedureRegionService } from "src/app/services/admission-grouped-procedure-region/admission-grouped-procedure-region.service";
import { PatientService } from "src/app/services/patient.service";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";

@Injectable({
  providedIn: "root",
})
export class IntegratedAdmissionControlWizardService extends IntegratedAdmissionWizardService {
  constructor(
    private activatedRoute: ActivatedRoute,
    public patientService: PatientService,
    public authService: AuthService,
    public router: Router,
    public notificationToastService: NotificationToastService,
    public onLineValidationService: OnLineValidationService,
    public integratedAdmissionService: IntegratedAdmissionService,
    public valorizationService: ValorizationService,
    public practiceService: PracticeService,
    public invoiceIntegratedAdmissionCashDeskService: InvoiceCashDeskService,
    public confirmDialogService: ConfirmDialogService,
    public budgetService: BudgetService,
    public dialog: MatDialog,
    public normativeService: NormativeService,
    public reservationService: ReservationService,
    public laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    public admissionGroupedProcedureRegionService: AdmissionGroupedProcedureRegionService,
  ) {
    super(
      authService,
      patientService,
      router,
      notificationToastService,
      onLineValidationService,
      integratedAdmissionService,
      valorizationService,
      practiceService,
      invoiceIntegratedAdmissionCashDeskService,
      confirmDialogService,
      budgetService,
      dialog,
      normativeService,
      reservationService,
      laboratoryAppointmentQuestionService,
      admissionGroupedProcedureRegionService,
    );
  }

  getConfirmDialog(): Observable<boolean> {
    return this.confirmDialogService.confirm(
      "Admisión",
      "¿Esta seguro que desea guardar la admisión?",
      "Guardar",
      "Cancelar",
      false,
      true,
      true,
    );
  }

  validateProceduresForValidationLoaded(): boolean {
    return false;
  }

  showPreAdmissionPatientAppointment(): boolean {
    return false;
  }

  canExtractProcedures(): boolean {
    return false;
  }

  linkAppointmentWait(): boolean {
    return false;
  }

  showAddAppointment(): boolean {
    return false;
  }

  showCopyAppointment(): boolean {
    return false;
  }

  showPrint(): boolean {
    return true;
  }

  cancel(): void {
    this.router.navigate(["admission-integrated-search"]);
  }

  async finish() {
    await this.save();
  }

  getReturnUrl(): string {
    return "integrated-reception-admission";
  }

  canRefreshPracticeToParticular(): boolean {
    return true;
  }

  async getInitAdmission(): Promise<IntegratedAdmissionAppointment[]> {
    const atention = this.activatedRoute.snapshot.paramMap.get("Atention");

    const readOnly = this.activatedRoute.snapshot.paramMap.get("ReadOnly");

    const appointments =
      await this.integratedAdmissionService.getControlAdmissions(
        this.sectorId,
        atention,
      );

    this.patientId = appointments[0].PatientId;

    if (readOnly === "true") {
      this.readonly = true;
    }

    return appointments;
  }

  async getNewAdmission(): Promise<IntegratedAdmissionAppointment> {
    throw new Error("No puede agregar una nueva admisión desde esta pantalla.");
  }
}
